module.exports = {
  path: 'contact_us',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ContactUs'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/more/routes/contact_us/index.js